import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const EgyptFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14643'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14643)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#E41D33'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#262626'
				/>
				<path
					d='M8.75079 6.6848L8.97962 7.13331H8.94847L8.8654 7.18759L8.46812 7.44714C8.24642 7.59199 7.95247 7.43291 7.95247 7.16808V6.26664C7.95247 6.08255 8.10171 5.93331 8.28581 5.93331L8.36738 5.93331L8.75079 6.6848ZM9.5239 7.13331H9.09352L9.33835 6.69653L9.33839 6.69645L9.33841 6.69643L9.33843 6.69639L9.33848 6.6963L9.33907 6.69525L9.34255 6.68917L9.35769 6.66331C9.37129 6.6404 9.39155 6.60698 9.41728 6.5666C9.46914 6.48521 9.54135 6.37847 9.62445 6.27335C9.70905 6.16632 9.79681 6.07138 9.87841 6.00613C9.95339 5.94615 9.99282 5.93556 9.99975 5.9337C10.0011 5.93334 10.0012 5.93331 10.0001 5.93331C10.012 5.93331 10.059 5.94137 10.1441 6.00813C10.225 6.0715 10.3096 6.16402 10.3901 6.26923C10.4692 6.37256 10.5364 6.47768 10.5842 6.55797C10.6079 6.59777 10.6263 6.63065 10.6386 6.65309L10.6521 6.67828L10.6552 6.68405L10.6556 6.6848L10.6556 6.68491L10.6557 6.68499L10.6557 6.68507L10.6557 6.6851L10.8844 7.13331H10.4763H10.143V7.46664V7.92378C10.143 8.00268 10.079 8.06664 10.0001 8.06664C9.9212 8.06664 9.85724 8.00268 9.85724 7.92379V7.46664V7.13331H9.5239ZM11.0517 7.13331H11.0206L11.2494 6.6848L11.6328 5.93331L11.7144 5.93331C11.8985 5.93331 12.0477 6.08255 12.0477 6.26664V7.16808C12.0477 7.43291 11.7538 7.59199 11.5321 7.44714L11.1348 7.18759L11.0517 7.13331Z'
					fill='#F4B32E'
					fillOpacity='0.25'
					stroke='#C6A846'
					strokeWidth='0.666667'
				/>
			</g>
		</svg>
	);
};

export default EgyptFlagIcon;
